import { FC, JSX } from 'react'
import { PushWizardModal } from './push-wizard/PushWizardModal'
import { PushWizardModalType } from './push-wizard/types'
import {
  NotificationActionsColumn,
  NotificationActionsColumnType,
} from './NotificationActionsColumn'
import { NotificationAnalytics, NotificationAnalyticsType } from './Analytics'

export const Notification: FC &
  PushWizardModalType &
  NotificationActionsColumnType &
  NotificationAnalyticsType = (): JSX.Element => <></>

Notification.Analytics = NotificationAnalytics
Notification.PushWizardModal = PushWizardModal
Notification.ActionsColumn = NotificationActionsColumn
